import {FilterPortalConfig} from "./filter-portal-config.model";

export class FiltersConfig {
  filtersConfig: FilterPortalConfig[] = [];

  constructor(attr: {
    filtersConfig?: any[]
  }) {
    if (attr.filtersConfig) {
      attr.filtersConfig.forEach(filterConfig => this.filtersConfig.push(new FilterPortalConfig(filterConfig)));
    }
  }
}
